import { createContext } from "react";
export const designTwoPagecounter = createContext(null);
export const designTwoMainCategories = createContext([]);
export const designTwoFavoriteInputsArray = createContext([]);